<template>  
<section>  
  <v-layout row wrap style="flex:1 0;overflow:auto;align-items:center;justify-content:center;" >
    <v-flex xs6 sm4 md3 lg2 class="pa-4">
      <v-card style="text-align:center" class="pa-2" :to="{name:'NewMapLayer'}" exact>
        <v-icon color="#444" size="100">mdi-map</v-icon>
        <v-card-title>{{$t('Configuration.MapLayers')}}</v-card-title>                      
      </v-card>      
    </v-flex> 
  </v-layout>    
</section>  
</template>

<script>
import Vue from 'vue'
import Component from 'vue-class-component'

@Component({
  name: 'HomeConfiguration', 
})
export default class HomeConfiguration extends Vue {  

  

}
</script>
<style>
</style>